import script from "./ItemSkuAttrs.vue?vue&type=script&setup=true&lang=ts"
export * from "./ItemSkuAttrs.vue?vue&type=script&setup=true&lang=ts"

import "./ItemSkuAttrs.vue?vue&type=style&index=0&id=2952ad88&lang=scss"

const __exports__ = script;

export default __exports__